import { connect } from 'react-redux'
import EditPanelComponent from '../components/EditPanel'

const mapStateToProps = state => {
  return {
    mapObject : state.mapObject,
    mapActions : state.mapActions,
    media : state.media
  }
}

const EditPanel = connect(
  mapStateToProps
)(EditPanelComponent)

export default EditPanel



// WEBPACK FOOTER //
// ./src/containers/EditPanel.js